<pos-app-spinner></pos-app-spinner>
<div class="mx-2">
  <form [formGroup]="manageHelpForm" class="mt-2">
    <!-- add manageHelpForm with this.manageHelpForm controls -->
    <div class="row">
      <div class="form-group col-md-4 d-flex align-items-center">
        <label for="userRole" class="mb-0 mr-2 min-width-100">User Role</label>
        <ng-select
          id="userRole"
          formControlName="userRole"
          [clearable]="false"
          [items]="userRoleArray"
          bindLabel="name"
          bindValue="value"
          placeholder="Select user role..."
          class="form-control border-0 p-0 ng-select-fullwidth noshadow"
        >
          <ng-option *ngFor="let role of userRoleArray" [value]="role">{{ role }}</ng-option>
        </ng-select>
      </div>
      <div class="form-group col-md-4 d-flex align-items-center">
        <label for="programmeCode" class="mb-0 mr-2 min-width-150">Programme Code</label>
        <ng-select
          id="programmeCode"
          formControlName="programmeCode"
          [clearable]="true"
          placeholder="Select programme code..."
          class="form-control border-0 p-0 ng-select-fullwidth noshadow"
        >
          <ng-option *ngFor="let code of partnerProgrammeList" [value]="code.programmeCode">{{ code?.programmeCode }}</ng-option>
        </ng-select>
      </div>
      <div class="form-group col-md-4 d-flex align-items-center">
        <label for="category" class="mb-0 mr-2 min-width-100">Category</label>
        <ng-select
          id="category"
          formControlName="customerCategory"
          [clearable]="true"
          placeholder="Select category..."
          class="form-control border-0 p-0 ng-select-fullwidth noshadow"
        >
          <ng-option *ngFor="let category of customerCategoryList" [value]="category?.customerCategoryCode">{{
            category?.customerCategoryDescription
          }}</ng-option>
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group d-flex align-items-center">
        <label for="headerPictureURL" class="col-md-2 mb-0 mr-2 max-width-150">Header Icon URL</label>
        <input
          id="headerPictureURL"
          type="text"
          formControlName="headerPictureURL"
          class="form-control"
          placeholder="Enter header icon URL here..."
        />
      </div>
    </div>
    <div class="form-group">
      <label for="headerText">Header Text</label>
      <angular-editor formControlName="headerText" [config]="editorConfig"></angular-editor>
    </div>
    <div formArrayName="tileArray" class="form-group">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label for="tileArray" class="mb-0">Tiles</label>
        <button type="button" class="btn btn-secondary" (click)="addItem(); currentPage = Math.ceil(tileArray.controls.length / pageSize)">
          Add Tile
        </button>
      </div>

      <div>
        <div style="overflow-x: auto">
          <table class="table table-bordered mb-0 min-width-800">
            <thead class="sticky-thead">
              <tr>
                <th>Actions</th>
                <th>Tile Name</th>
                <th>Tile URL</th>
                <th>Tile Icon</th>
                <th>Load in New Tab</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let tile of tileArray.controls | slice : (currentPage - 1) * pageSize : currentPage * pageSize; let i = index"
                [formGroupName]="(currentPage - 1) * pageSize + i"
              >
                <td>
                  <mat-icon (click)="removeItem((currentPage - 1) * pageSize + i)">delete</mat-icon>
                </td>
                <td>
                  <input type="text" formControlName="label" class="form-control" placeholder="Enter tile name here..." />
                </td>
                <td>
                  <input type="text" formControlName="url" class="form-control" placeholder="Enter tile URL here..." />
                </td>
                <td>
                  <input type="text" formControlName="icon" class="form-control" placeholder="Enter tile icon url here..." />
                </td>
                <td class="text-center">
                  <input type="checkbox" formControlName="loadInNewTab" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav *ngIf="tileArray.controls.length > pageSize" class="mt-2">
          <ul class="pagination justify-content-center mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" type="button" (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">&laquo;</button>
            </li>
            <li
              class="page-item"
              *ngFor="let page of [].constructor(Math.ceil(tileArray.controls.length / pageSize)); let p = index"
              [class.active]="currentPage === p + 1"
            >
              <button class="page-link" type="button" (click)="currentPage = p + 1">{{ p + 1 }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === Math.ceil(tileArray.controls.length / pageSize)">
              <button
                class="page-link"
                type="button"
                (click)="currentPage = currentPage + 1"
                [disabled]="currentPage === Math.ceil(tileArray.controls.length / pageSize)"
              >
                &raquo;
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button type="button" class="btn text-uppercase" [disabled]="manageHelpForm.invalid || invalid" (click)="submitForm()">Save</button>
    <button type="button" class="btn btn-cancel text-uppercase" (click)="closeModal()">Cancel</button>
  </div>
</div>
